import axios from '@axios'

const PREFIX = '/pessoas'

export default {

  getPessoas(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getPessoa(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  updatePessoa(id, pessoa) {
    return axios.put(`${PREFIX}/${id}`, pessoa)
  },

  createPessoa(pessoa) {
    return axios.post(`${PREFIX}/add`, pessoa)
  },

  deletePessoa(id, inativar) {
    return axios.delete(`${PREFIX}/${id}?inativar=${inativar}`)
  },

  deleteAll(idList) {
    return axios.delete(`${PREFIX}/lote`, { data: idList })
  },

  validaEmail(id, email) {
    if (id) {
      return axios.get(`${PREFIX}/${id}/email/${email}`)
    }
    return axios.get(`${PREFIX}/email/${email}`)
  },

  getPessoasResumidas(filtro) {
    return axios.post(`${PREFIX}/resumido`, filtro)
  },

  verificaVinculo(id) {
    return axios.post(`${PREFIX}/vinculo?id=${id}`)
  },

  autorizar(propostaPessoa) {
    return axios.post(`${PREFIX}/portal-proposta/acesso`, propostaPessoa)
  },

  salvarMensagem(id) {
    return axios.put(`${PREFIX}/${id}/portal-proposta/primeiro-acesso-pessoa`)
  },

  mostrarMensagem(id) {
    return axios.get(`${PREFIX}/${id}/portal-proposta/mensagem-primeiro-acesso`)
  },

  existeMaisDeUmaProposta(id, status) {
    return axios.get(`${PREFIX}/${id}/existe-propostas?eStatusProposta=${status}`)
  },

  getEmpresasPessoa(id) {
    return axios.get(`${PREFIX}/${id}/empresas`)
  },
}
